<template>
	<article class="layout-3-col-wrapper">
		<div class="left"></div>
		<div class="middle">

			<div class="content-frame column">
				<spinner v-if="installedPollsStatus.loading"></spinner>
				<div v-if="!installedPollsStatus.loading">
					<div v-if="installedPolls && installedPolls.length">
						<div v-for="poll in sortedInstalledPolls" v-bind:key="poll.id" :class="`poll ${deleteStatus.loading && poll.id === pollId && 'deleting' } `">
							<div class="poll-image">
								<img v-bind:src="poll.marketItem.logo">
							</div>
							<div class="poll-details">
							<h3 class="title">{{poll.name}}</h3>
								<div>Integration:</div>
								<div>{{poll.marketItem.name}}</div>
								<div>Bucket:</div>
								<div v-if="poll.iotBucketName">
									<a :href="getIotBucketURL(poll.iotBucketId)" target="_blank">{{ poll.iotBucketName }}
										<span>
											<i class="fas fa-share-square fa-sm"></i>
										</span>
									</a>
								</div>
								<div v-else>
									Bucket not found
								</div>
								<div>Installed:</div>
								<div>
									{{poll.createdOn | date('long_with_time')}}
								</div>
								<div>Status:</div>
								<div class="poll-status">
									<span>{{poll.state}}</span>
									<span v-if="!poll.processing" :class="`${poll.state}`"></span>
									<spinner v-if="poll.processing" class="inline-loader" hideText="true"></spinner>
									<span v-if="poll.credits && poll.state === 'ACTIVE'">  {{poll.credits}} <span class="token align-top"></span> </span>
								</div>
							</div>
							<div v-if="deleteStatus.loading && pollId === poll.id">
								<i class="fas fa-spinner fa-spin fa-2x text-center"></i>
							</div>
							<div v-else class="poll-actions" ref="dropdownMenu">
								<button :class="`${showMenu && poll.id === pollId && 'active'} outline-btn`"   @click="handleActionClick($event, poll.id)">Actions <i class="fas fa-caret-down"></i></button>
								<ul v-if="showMenu && poll.id === pollId" class="action-menu"  >
									<li v-if="poll.isActive()"><a  @click="showWarning(poll.id, 'deactivate')">Deactivate</a></li>
									<li v-if="poll.isInactive()"><a  @click="showWarning(poll.id, 'activate')">Activate</a></li>
									<li><router-link :to="{ name: 'pollDetails', params: { pollId: poll.id }}">Manage</router-link></li>
									<li><a @click="showWarning(poll.id, 'delete')">Remove</a></li>
								</ul>
							</div>
							<div v-if="showActivationWarning === true && pollId === poll.id" class="activate-warning notice text-center">
								<div v-if="poll.credits && poll.credits > credits.remaining">
									<p>You do not have enough credits to activate this integration.</p>
									<router-link tag="button" to="/credits">Go to credits</router-link>
									<button @click="hideWarning()">OK</button>
								</div>
								<div v-else>
									<p v-if="poll.credits">
										<span>This will use <span class="token"></span> {{poll.credits}}</span>
									</p>
									<p>
										Are you sure you want to activate this integration?
									</p>
									<button @click="hideWarning()">Cancel</button>
									<button @click="activatePoll(poll.id)">Yes, activate it!</button>
								</div>
							</div>
							<div v-if="showDeactivationWarning === true && pollId === poll.id" class="deactivate-warning notice text-center">
								<p v-if="poll.credits">
									This will free up <span class="token"></span> {{poll.credits}}.
								</p>
								<p>
									Are you sure you want to deactivate this integration?
								</p>
								<button @click="hideWarning()">Cancel</button>
								<button @click="deactivatePoll(poll.id)">Yes, deactivate it!</button>
							</div>
							<div v-if="showDeletionWarning === true && pollId === poll.id" class="remove-warning notice text-center">
								<p>By removing this integration you will no longer get new data.
									Your current data will not be affected. This cannot be undone.
									Are you sure you want to remove this integration?</p>
								<button @click="hideWarning()">No, I'll keep this integration.</button>
								<button @click="deletePoll(poll.id)">Yes, remove it!</button>
							</div>
						</div>
					</div>
					<div v-else class="installed-inegrations__empty">
						<header class="sub-header"><hr><span class="circle"></span><h2>You Haven't Setup Any Integrations, Yet.</h2><span class="circle"></span><hr></header>
						<p class="text-center"><router-link class="rigid" :to="{ name: 'marketplace'}">Browse </router-link> our integrations to get started!</p>
					</div>
				</div>
			</div>

		</div>
		<div class="right"></div>
	</article>
</template>

<script>
	import date from '../filters/date';
	import Spinner from '../components/Spinner';
	import DropdownMenu from '../components/DropdownMenu';
	import { mapGetters } from 'vuex';

	export default {
		name: 'Manage',
		filters: {
			date
		},
		data(){
			return {
				pollId: "",
				showDeletionWarning: false,
				showActivationWarning: false,
				showDeactivationWarning: false,
				showMenu: false,
			};
		},
		components: {
			Spinner,
			DropdownMenu
		},
		computed: {
			...mapGetters([
				'appURL',
				'buckets',
				'deleteStatus',
				'listBucketsStatus',
				'installedPolls',
				'installedPollsStatus',
				'roles',
				'credits',
				'user',
			]),
			sortedInstalledPolls: function() {
				function compare(a, b) {
					if (a.createdOn < b.createdOn) {
						return 1;
					} else if (a.createdOn > b.createdOn) {
						return -1;
					}
					return 0;
				}
				return [...this.installedPolls].sort(compare);
			}
		},
		methods: {
			handleActionClick(e, pollId) {
				this.hideWarning(); // reset any warnings shown on other item
				this.showMenu = !this.showMenu;
				this.showMenu ? this.pollId = pollId : this.pollId = '';

				if (this.showMenu) {
					window.addEventListener('click', this.documentClick, true);
					return;
				}

				this.removeListeners();

			},
			getIotBucketURL(bucketId) {
				return this.appURL + `&destination=/tiles/${bucketId}`;
			},
			deletePoll(pollId) {
				this.pollId = pollId;
				let payload = {
					pollId
				};
				this.$store.dispatch('POLLS_REQUEST_DELETE', payload);
				this.hideWarning();
			},
			showWarning(pollId, warningType = ''){
				this.pollId = pollId;
				if (warningType === 'activate') {
					this.showActivationWarning = true;
				} else if (warningType === 'deactivate') {
					this.showDeactivationWarning = true;
				} else if (warningType === 'delete') {
					this.showDeletionWarning = true;
				}
				this.showMenu = false;
			},
			hideWarning(){
				this.showActivationWarning = false;
				this.showDeactivationWarning = false;
				this.showDeletionWarning = false;
			},
			deactivatePoll(pollId) {
				this.showMenu = false;
				let payload = {
					pollId,
					state: 'INACTIVE'
				};
				this.$store.dispatch('POLLS_REQUEST_UPDATE_STATE', payload);
				this.hideWarning();
			},
			activatePoll(pollId) {
				this.showMenu = false;

				let payload = {
					pollId,
					state: 'ACTIVE'
				};
				this.$store.dispatch('POLLS_REQUEST_UPDATE_STATE', payload);
				this.hideWarning();
			},
			 documentClick(e){
				let target = e.target.offsetParent || e.target;
				const isTrigger = target.classList.contains('action-menu');

				if (isTrigger) {
					//return out and let the trigger hide/show menu
					return;
				}

				if (this.showMenu) {
					this.showMenu = false;
					this.removeListeners();
				}
			},
			removeListeners() {
				window.removeEventListener('click', this.documentClick, true);
			}
		},
		created() {
			this.$store.dispatch('POLLS_REQUEST_GET_INSTALLED', { matchBuckets: true });
		},
		destroyed() {
			window.removeEventListener('click', this.documentClick, true);
		}

	};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

	.layout-3-col-wrapper{
		flex-wrap: wrap;
	}
	.right, .left{
		flex-basis: 0;
	}
	.remove-warning,
	.deactivate-warning,
	.activate-warning{
		flex-basis: 100%;
	}
	.content-frame > .loading{
		margin-top:150px;
	}
	.poll.deleting{
		opacity: 0.5;
	}

	.poll:hover .outline-btn{
		color:white;
		transition: all .2s ease;
		border-color: rgba(16,116,231);
		background-color: rgba(16,116,231);
		color: white;
		font-size: 12px;
	}
	.poll:hover .outline-btn:hover{
		font-size: 12px;
		background-color: #2C8EFF;
		text-shadow: 0 2px 4px rgba(5,9,133,0.50);
		color: white;
		border-color: rgba(16,116,231);
	}
	.poll {
		max-width:600px;
		margin: 20px auto;
		background-color: #F9FCFF;
		/* background-color: #F8F8F8; */
		box-shadow: 0 1px 5px 0 rgba(72,137,207,0.09);


		padding: 20px;
		/* box-shadow: 0 1px 5px 0px rgba(205,205,205,.5); */
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: space-between;
		flex-wrap: wrap;
		background-color: #f1f3f6;
		-webkit-box-shadow: 5px 5px 10px 0 rgba(61,66,67,0.05);
		box-shadow: 5px 5px 10px 0 rgba(61,66,67,0.05);
		border: .66px solid white;
	}
	.poll .title{
		grid-column-start: 1;
		grid-column-end: 3;
		grid-row-start: 1;
		grid-row-end: 1;
		margin: 0 0 10px;

	}
	.poll-image{
		padding-right: 10px;
	}
	.poll-image img{
		max-width:65px;
	}
	.poll-details{
		display: grid;
		grid-template-columns: 85px auto;
		grid-gap: 5px 0;
		flex: 1 1 auto;
		margin-left: 20px;
	}
	.poll-details span{
		display: inline-block;
	}
	.poll-actions{
		position:relative;

	}
	.poll-status span.ACTIVE{
		background-color: #06D6A0;
	}
	.poll-status span.INACTIVE{
		background-color: #666;
	}
	.poll-status span.ACTIVE,
	.poll-status span.INACTIVE {
		height: 9px;
		width: 9px;
		border-radius:50%;
		display:inline-block;
	}
	.poll-status{
		text-transform: lowercase;
	}
	.poll-status > span::first-letter{
		text-transform: uppercase;
	}
	.installed-integrations__empty{
		text-align:center;
		width:600px;
		border-left:none;
		border-right:none;
		padding: 40px;
		display: flex;
		align-items: center;
		flex-direction: column;
	}
	.action-menu{
		position:absolute;
		width:auto;
		background-color: #f8f8f8;
		border: 1px solid #d8d8d8;
		margin: 0;
		margin-top: -2px;
		z-index: 1;
		border-radius: 6px;
		box-shadow: 0 1px 5px 0px rgba(205,205,205,.5);
	}
	.action-menu a{
		list-style: none;
		padding: 10px 20px;
		display: block;
		cursor: pointer;
		transition: all .2s ease;
	}
	.action-menu li:last-of-type a{
		border-bottom-right-radius: 6px;
		border-bottom-left-radius: 6px;
	}
	.action-menu li:first-of-type a{
		border-top-right-radius: 6px;
		border-top-left-radius: 6px;

	}
	.action-menu li{
		list-style-type: none;
	}
	.action-menu li:hover a{
		background-color: #337CCA;
		color:white;
	}
	.installed-integrations__empty p{
		margin: 15px auto;
	}
	.sub-header{
		color:#222;
		text-align: center;
		padding: 15px 0;
		display:flex;
		flex-direction: row;
		max-width: 600px;
		margin: auto;
		padding-top: 30px;
		align-items: center;
		flex: 1;

	}
	.sub-header ~ .layout-3-col-wrapper > .middle{
		padding-top: 0;
	}
	.sub-header h2{
		margin:0 15px;
	}
	.sub-header hr{
		flex: 1 1 auto;
		border:none;
		border-bottom: solid thin #222;
	}


		/* // Extra small devices (portrait phones, less than 576px) */
@media (max-width: 575.98px) {

	.sub-header ~ .layout-3-col-wrapper > .middle{
		width:100%;
		flex-basis:100%;
		padding:20px 0 40px;
	}

	.poll{
		flex-direction: column;
		max-width:80%;
		margin: auto auto 25px;
	}

	.poll-actions{
		margin:10px auto;
	}

	.poll-image{
		margin-right: none;
	}

  }

/* // Small devices (landscape phones, 576px and up) */
@media (min-width: 576px) and (max-width: 767.98px) {

	.sub-header ~ .layout-3-col-wrapper > .middle{
		width:100%;
		flex-basis:100%;
		padding:20px 0 40px;
	}
}

/* // Medium devices (tablets, 768px and up) */
@media (min-width: 768px) and (max-width: 991.98px) { .item-tile{display:none;}}

/* // Large devices (desktops, 992px and up) */
@media (min-width: 992px) and (max-width: 1199.98px) {.item-tile{display:none;}  }

/* // Extra large devices (large desktops, 1200px and up) */
@media (min-width: 1200px) {

}

.align-top {
	vertical-align: top;
}
</style>



// WEBPACK FOOTER //
// src/views/Manage.vue